import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AppState from '../../../models/redux/state/app.state';
import useProfileHook from '../../../services/profileHook';

const PrivateRoute: React.FC<{
  component: React.FC;
  path: string;
  tempUserAccess?: boolean;
}> = (props) => {
  useProfileHook();
  const user = useSelector((state: AppState) => state.auth.user);
  const { component, path, tempUserAccess = false } = { ...props };
  const hasTempUserAccess = !user?.tmpUser || (user?.tmpUser && tempUserAccess);

  return user && hasTempUserAccess ? <Route path={path} component={component} /> : <Redirect to="/login" />;
};

export default PrivateRoute;
